import React from 'react';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { AttributeGroupPersonsBlock } from '../../_blocks/AttributeGroupPersons';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { isEmptyBlock } from '../../types/api/Block';
import { isNullOrUndefined } from '../../lib/typeGuards';

export type AttributeGroupPersonsWidget = WidgetShape<AttributeGroupPersonsBlock, WidgetType.attributegrouppersons>;

export function AttributeGroupPersonsWidget({ blocks, uuid, elementType }: AttributeGroupPersonsWidget) {
  const { t } = useSonTranslation('AttributeGroups');

  if (isNullOrUndefined(blocks[0]) || isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      icon={Icons.MEMBERS}
      uuid={uuid}
      title={t('personsInThisGroup')}
      widgetType={elementType}
      header={false}
    >
      <AttributeGroupPersonsBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
